
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class MokYun extends Vue {
  public calleft = 0;
  public speed = 1;
  public timer: any;
  @Prop() private msg!: any;
}
